export class UpcomingTrips {
  public totaltrips: string;
  public viewAlltrips: string;
  public transactionId: string;
  public carTripDetails: CarTripModel;
  public vacationTripDetails: VacationTripModel;
  public flightTripDetails: FlightTripModel;
  public hasUpComingTrip = false;
}

export class CarTripModel {
  public detailsLink: string;
  public pickupCity: string;
  public dateRange: string;
  public vendorConfirmationNbr: string;
  public vendorName: string;

  constructor(
    detailsLink: string,
    dateRange: string,
    pickupCity: string,
    vendorConfirmationNbr: string,
    vendorName: string
  ) {
    this.detailsLink = detailsLink;
    this.dateRange = dateRange;
    this.pickupCity = pickupCity;
    this.vendorConfirmationNbr = vendorConfirmationNbr;
    this.vendorName = vendorName;
  }
}

export class FlightTripModel {
  public checkedIn: boolean;
  public checkinEligible: boolean;
  public checkinLink: string;
  public dateRange: string;
  public destinationCity: string;
  public detailsLink: string;
  public iropClean: boolean;
  public iropImpact: boolean;
  public iropMessage: string;
  public pnrNbr: string;

  constructor(
    checkedIn: boolean,
    checkinEligible: boolean,
    checkinLink: string,
    dateRange: string,
    destinationCity: string,
    detailsLink: string,
    iropClean: boolean,
    iropImpact: boolean,
    iropMessage: string,
    pnrNbr: string
  ) {
    this.checkedIn = checkedIn;
    this.checkinEligible = checkinEligible;
    this.checkinLink = checkinLink;
    this.dateRange = dateRange;
    this.destinationCity = destinationCity;
    this.detailsLink = detailsLink;
    this.iropClean = iropClean;
    this.iropImpact = iropImpact;
    this.iropMessage = iropMessage;
    this.pnrNbr = pnrNbr;
  }
}

export class VacationTripModel {
  public checkedIn: boolean;
  public checkinEligible: boolean;
  public checkinLink: string;
  public dateRange: string;
  public depCityName: string;
  public detailsLink: string;
  public iropClean: boolean;
  public iropImpact: boolean;
  public iropMessage: string;
  public vacationConfirmationNbr: string;

  constructor(
    checkedIn: boolean,
    checkinEligible: boolean,
    checkinLink: string,
    dateRange: string,
    depCityName: string,
    detailsLink: string,
    iropClean: boolean,
    iropImpact: boolean,
    iropMessage: string,
    vacationConfirmationNbr: string
  ) {
    this.checkedIn = checkedIn;
    this.checkinEligible = checkinEligible;
    this.checkinLink = checkinLink;
    this.dateRange = dateRange;
    this.depCityName = depCityName;
    this.detailsLink = detailsLink;
    this.iropClean = iropClean;
    this.iropImpact = iropImpact;
    this.iropMessage = iropMessage;
    this.vacationConfirmationNbr = vacationConfirmationNbr;
  }
}

export class TripOptions {
  public skymilesNbr: string;
  public nmbrOfTrips: string;

  constructor(skymilesNbr: string, nmbrOfTrips: string) {
    this.skymilesNbr = skymilesNbr;
    this.nmbrOfTrips = nmbrOfTrips;
  }
}

// export class Errors {
//   public code : string;
//   public description : string;
//   public inputParam : string;
//   public stackTrace : string;
// }
